import React from "react";
import { Form } from "react-bootstrap";
import "./ReclaimedMaterialsInfo.css";

interface ReclaimedMaterialsInfoProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ReclaimedMaterialsInfo: React.FC<ReclaimedMaterialsInfoProps> = ({
  formData,
  setFormData,
}) => {
  const isNotApplicable = formData.Reclaimed_Materials_Information__c || false;
  const description = formData.Description_of_the_organization_s_verifi__c || "";

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData: any) => ({
      ...prevData,
      Reclaimed_Materials_Information__c: e.target.checked,
    }));
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFormData((prevData: any) => ({
      ...prevData,
      Description_of_the_organization_s_verifi__c: e.target.value,
    }));
  };

  return (
    <>
      <div className="reclaimed-materials-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          Reclaimed Materials Information
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="is-not-applicable-checkbox"
          label="N/A"
          className="na-checkbox"
          checked={isNotApplicable}
          onChange={handleCheckboxChange}
        />
      </div>
      <div className="p-3">
        <p className="reclaimed-materials-description-label">
          Description of the organization's verification program for reclaimed materials
        </p>
        <span>
          (i.e. type of material sourced, material receipt/segregation, supplier audits)
        </span>

        <Form.Control
          as="textarea"
          rows={7}
          placeholder="Add a description..."
          className="mt-3"
          value={description}
          onChange={handleDescriptionChange}
        />
      </div>
    </>
  );
};

export default ReclaimedMaterialsInfo;
